<template>
    <div style="display: flex; flex-direction: column; align-items: center;">
        <h1>Page Not Found!</h1>
        <div>
            <a href="/">Go Home</a>
            <span> | </span>
            <a href="javascript:void(0)" @click="$userManager.logout()">Logout</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "404"
    }
</script>

<style scoped>

</style>
